<template>
  <div class="test-videojs">
    <video
      ref="videoPlayer"
      id="videoPlayer"
      class="video-js"
      :muted="false"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsInline="true"
      x5-playsinline="true"
      x5-video-orientation="portraint"
    ></video>

    <div class="video-mask" @click="pauseVideo">
      <!-- <div class="video_play_btn" @click.stop="playVideo"></div> -->
    </div>
    <div v-if="!isLoading || !videoSrc" class="video_loading" @click="playVideo">
      <div class="video_loading_box">
        <img src="@/static/images/player/video_loading.png" />
        <div class="video_loading_light"></div>
      </div>
    </div>
    <div v-if="!isLoading || !videoSrc" class="btm_box fadeIn" @click="showListPop">
      <div class="btm_box_light"></div>
    </div>

    <div v-if="os != 'ios' && !hasClickPlay" class="android_guide_box" @click="playVideo">
      <img class="guide_bg" :src="theatreDetail.cover_url" />
      <div class="guide_toast">
        <img src="@/static/images/player/icon-play.png" />
        <p>点击继续观看</p>
      </div>
    </div>
    <!-- 视频控制浮层 -->
    <div v-if="showCtrls">
      <div
        class="v_control"
        :style="{ 'background-color': sildeTouchFlag ? 'rgba(0, 0, 0, 0.3)' : '' }"
        @tap.stop
        @click="playVideo"
      >
        <div class="v_pause">
          <img src="@/static/images/player/icon-play.png" />
        </div>
        <div v-if="sildeTouchFlag" class="v_time">
          <p
            v-if="isLoading && currentTime <= totalTime && currentTime > 0.2"
            class="v_time_txt1 numberItalic"
          >
            {{ currentTime | timeFormatMMss() }}
          </p>
          <p v-else class="v_time_txt1 numberItalic">00:00</p>

          <p class="v_time_txt_icon">/</p>

          <p v-if="isLoading" class="v_time_txt2 numberItalic">
            {{ totalTime | timeFormatMMss() }}
          </p>
          <p v-else class="v_time_txt2 numberItalic">00:00</p>
        </div>
      </div>
    </div>

    <!-- 底部选集按钮 -->
    <div
      class="overlay_btm_box save_area"
      :class="[playerModel == 'immersion' ? 'fadeBottomOut' : '']"
      @click="showListPop"
    >
      <img class="btm_box_left" src="@/static/images/player/icon-bottom-menu.png" />

      <div class="btm_box_tit">
        <p>《</p>
        <p class="btm_box_tit_name">{{ theatreDetail && theatreDetail.name }}</p>
        <p>》{{ theatreDetail.is_end ? '已完结' : '更新中' }}·第</p>
        <p class="numberItalic">{{ episode }}</p>
        <p>集</p>
      </div>
      <img class="btm_box_right" src="@/static/images/player/icon-arrow.png" />
    </div>
    <!-- 进度条 -->
    <div v-if="videoIsLoaded" class="progress_bar_box">
      <div
        class="progress_bar_bg"
        :style="{
          height: sildeTouchFlag ? $options.filters.px2rem(20) : $options.filters.px2rem(8),
          'margin-top': sildeTouchFlag ? $options.filters.px2rem(-8) : $options.filters.px2rem(2)
        }"
      ></div>
      <div
        class="progress_bar"
        :style="{
          width: $options.filters.px2rem(progressWidth),
          height: sildeTouchFlag ? $options.filters.px2rem(20) : $options.filters.px2rem(8),
          top: sildeTouchFlag ? $options.filters.px2rem(-6) : $options.filters.px2rem(8),
          opacity: sildeTouchFlag ? 1 : 0.2
        }"
      ></div>
      <div class="progress_bar_slide" @click="changeVideoCur" />
      <div
        class="progress_bar_point_box"
        :style="{
          left: $options.filters.px2rem(progressPointLeft - 15),
          top: sildeTouchFlag ? $options.filters.px2rem(-16) : $options.filters.px2rem(-10)
        }"
        @touchstart.stop="slideTouchStart"
        @touchmove.stop="slideTouchMove"
        @touchend.stop="slideTouchEnd"
      >
        <div
          class="progress_bar_point"
          :style="{
            width: sildeTouchFlag ? $options.filters.px2rem(16) : $options.filters.px2rem(10),
            height: sildeTouchFlag ? $options.filters.px2rem(32) : $options.filters.px2rem(10),
            opacity: sildeTouchFlag ? 1 : 0.4
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Videojs from 'video.js' // 引入Videojs
export default {
  props: {
    os: {
      type: String,
      default: ''
    },
    theatreDetail: {
      type: Object,
      default: null
    },
    videoDetail: {
      type: Object,
      default: null
    },
    videoSrc: {
      type: String,
      default: ''
    },
    episode: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    return {
      muted: true,
      player: null,
      // https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8 是一段视频，可将cctv1 （是live现场直播，不能快退）的替换为它，看到快进快退的效果
      videoIsLoaded: false,
      sildeTouchFlag: false,
      progressWidth: 0,
      progressPointLeft: 0,
      isLoading: false,
      playerModel: 'normal',
      showCtrls: false,
      playerState: '',
      hasClickPlay: false, //安卓是否点击播放
      startTime: 0,
      curRealSeeDuration: 0,
      curVideoReportPlay: false
    }
  },
  computed: {
    ...mapGetters(['referer', 'currentPage']),
    currentTime() {
      return this.player ? this.player.currentTime() : 0
    },
    totalTime() {
      return this.player ? this.player.duration() : 0
    }
  },
  watch: {
    currentTime(newV) {
      if (this.currentTime == 0) return 0
      this.progressWidth = 750 * (newV / this.totalTime)
      this.progressPointLeft = 750 * (newV / this.totalTime)
    }
  },
  beforeDestroy() {
    this.disposePlayer()
  },
  mounted() {
    // 上面配置错误也无所谓的，即使配置失败，也会走 ready 函数
    // 主要目的就是为了走 ready 函数
    if (this.os != 'ios') {
      this.muted = false
    }
    this.initVideo(this.videoSrc)
    //尝试监听物理返回
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.routerBack, false)
      console.log('支持')
    }
  },
  distoryed() {
    console.log('播放器销毁===', this.player)
    this.player && this.player.dispose()
  },
  methods: {
    routerBack() {
      this.disposePlayer()
      this.$router.replace('/homePage')
    },
    disposePlayer() {
      try {
        this.player && this.player.dispose()
        this.$refs.videoPlayer.dispose()
      } catch (err) {
        console.log('disposePlayererr', err)
      }
    },
    //切换播放器链接
    changeSrc(src) {
      let duration = this.curRealSeeDuration
      console.log('短剧播放-curRealSeeDuration', duration)
      console.log('短剧播放-startTime', this.startTime)
      console.log('短剧播放-duration', new Date().getTime() - this.startTime)
      if (this.startTime > 0) {
        duration = duration + (new Date().getTime() - this.startTime)
      }
      REPORT_SDK.report({
        event_id: 'player_playing',
        event_name: '短剧播放',
        referer: this.currentPage,
        scene: this.videoDetail.is_cost == 1 ? '付费剧集' : '免费剧集',
        page_name: String(this.videoDetail.episode),
        page_url: String(this.theatreDetail.id),
        page_type: String(Math.ceil(this.currentTime)),
        result: String(this.currentTime >= this.totalTime ? '播完结束' : '主动结束'),
        ext_field_1: String(Math.ceil(duration / 1000))
      })
      this.resetReportParams()
      this.player.src([
        {
          src,
          type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
        }
      ])
    },
    //清空埋点所需数据状态
    resetReportParams() {
      this.curVideoReportPlay = false
      this.startTime = 0
      this.curRealSeeDuration = 0
    },
    pauseVideo() {
      this.player.pause()
    },
    playVideo() {
      this.player.play()
    },
    seekVideo(e) {
      this.player.seek(e)
    },
    initPlay() {
      const playIntval = setTimeout(() => {
        if (this.playerState == 'playing') clearInterval(playIntval)
        try {
          console.log('调用play')
          this.player.play()
          this.$refs.videoPlayer.play()
        } catch (error) {
          console.log(
            'video被阻止了,需要手动触发按钮或别的事件，和用户有交互后 ，再调用play()',
            error
          )
        }
      }, 300)
    },
    initVideo(src) {
      // 这些options属性也可直接设置在video标签上，见 muted
      let options = {
        autoplay: true, // 设置自动播放
        controls: false, // 显示播放的控件
        sources: [
          // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了videoSrc也没实现)
          {
            src,
            type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
          }
        ],
        controlBar: {
          // 设置控制条组件
          //设置控制条里面组件的相关属性及显示与否
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          // 音量条的横向还是纵向显示
          volumePanel: {
            inline: false
          },
          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'progressControl' }, // 播放进度条
            { name: 'volumePanel' }
          ]
        }
      }
      // videojs的第一个参数表示的是，文档中video的id
      this.player = Videojs('videoPlayer', options, () => {
        console.log('ready', this.player, this.$refs)
        if (this.os == 'ios') {
          this.initPlay()
        } else {
          this.player.play()
        }
        this.player.on('playing', () => {
          console.log('playing')
          if (this.startTime == 0) {
            this.startTime = new Date().getTime()
            console.log('设置开始时间:', new Date().getTime(), new Date())
          }
          this.playerState = 'playing'
          this.videoIsLoaded = true
          this.showCtrls = false
          this.hasClickPlay = true
          this.isLoading = true
          //todo 往vuex 设置开始时间
          this.$emit('onPlaying')
          if (!this.curVideoReportPlay) {
            this.$emit('reportPlaying')
            this.curVideoReportPlay = true
          }
        })
        this.player.on('pause', () => {
          this.playerState = 'pause'
          if (this.startTime > 0) {
            console.log('增加短剧播放时长curRealSeeDuration', this.curRealSeeDuration)
            console.log('增加短剧播放时长now', new Date().getTime())
            console.log('增加短剧播放时长startTime', this.startTime)
            console.log('增加短剧播放时长duration', new Date().getTime() - this.startTime)
            this.curRealSeeDuration =
              this.curRealSeeDuration + (new Date().getTime() - this.startTime)

            this.startTime = 0
          }
          console.log('pause')
          //todo 往vuex 计算观看时长，清除开始时间
          this.showCtrls = true
          this.$emit('pausePlay')
        })
        this.player.on('ended', () => {
          console.log('ended')
          //todo 往vuex 计算观看时长，清除开始时间
          this.$emit('endPlay')
        })
        this.player.on('waiting', () => {
          console.log('waiting')
        })
        this.player.on('loadstart', (e) => {
          console.log('loadstart', e)

          if (this.$store.state.common.firstCanplaythrough) {
            REPORT_SDK.report({
              event_id: 'first_video_load_time',
              event_name: '首个视频加载时长',
              ext_field_1: String(new Date().getTime() - this.$store.state.common.appStartTime),
              page_url: String(this.$route.query.video_id)
            })
            this.$store.commit('common/REPORTED_FIRST_VIDEO')
          }
        })
        this.player.on('canplaythrough', () => {
          //视频可以播放监听事件
          console.log('canplaythrough')
        })
        this.player.on('error', (e) => {
          console.log('error', e)
        })
      })
    },
    slideTouchStart() {
      this.pauseVideo()
      this.sildeTouchFlag = true
    },
    slideTouchMove(e) {
      // const curTime = this.totalTime * (e.changedTouches[0].clientX / document.body.clientWidth);
      // this.player.currentTime(curTime);
      this.progressWidth = 750 * (e.changedTouches[0].clientX / document.body.clientWidth)
      this.progressPointLeft = 750 * (e.changedTouches[0].clientX / document.body.clientWidth)
    },
    slideTouchEnd(e) {
      this.sildeTouchFlag = false
      const curTime = this.totalTime * (e.changedTouches[0].clientX / document.body.clientWidth)
      this.player.currentTime(curTime)

      this.playVideo()
    },
    changeVideoCur(e) {
      const curTime = this.totalTime * (e.pageX / 375)
      console.log('seek-', e)
      this.player.currentTime(curTime)
    },
    showListPop() {
      console.log('[player]===showListPop===>')
      this.$emit('showListPop')
    }
  }
}
</script>
<style lang="less">
#videoPlayer {
  position: absolute;
  left: 0;
  top: 0;
  width: 750px;
  height: 100vh;
}
.android_guide_box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 750px;
  height: 100vh;
  .guide_bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 750px;
    height: 100vh;
  }
  .guide_toast {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.8);
    width: 450px;
    height: 200px;
    animation-duration: 300ms;
    animation-name: scaleAni;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-direction: alternate-reverse;
    position: absolute;
    bottom: 250px;
    left: 150px;
    img {
      width: 80px;
      height: 80px;
      margin-right: 30px;
    }
    p {
      font-size: 42px;
      font-weight: 600;
      color: #fff;
    }
  }
}
@keyframes scaleAni {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}
@keyframes lineAni {
  0% {
    transform: scaleX(0.1);
  }
  100% {
    transform: scaleX(1);
  }
}
.video_loading {
  z-index: 1;
  background: #000;
  width: 750px;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .video_loading_box {
    position: relative;
    width: 200px;
    height: 200px;
    overflow: hidden;
    .video_loading_light {
      width: 200px;
      height: 100px;
      background: linear-gradient(
        150deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(0, 0, 0, 0) 100%
      );
      animation: loadingLight 1050ms;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
    }
    @keyframes loadingLight {
      0% {
        transform: translateY(-100px);
      }
      100% {
        transform: translateY(300px);
      }
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 200px;
      height: 200px;
      z-index: 1;
    }
  }
}
.video-mask {
  width: 750px;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .video_play_btn {
    width: 200px;
    height: 200px;
    background: red;
  }
}

.progress_bar_box {
  width: 750px;
  height: 20px;
  position: absolute;
  display: flex;
  bottom: 120px;
  align-items: center;
  z-index: 99;
  .progress_bar_bg {
    width: 750px;
    height: 8px;
    background: rgba(255, 255, 255, 0.1);
    transition: all;
    transition-duration: 100ms;
  }
  .progress_bar {
    position: absolute;
    width: 20px;
    height: 8px;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
    transition: height 100ms, top 100ms;
    opacity: 0.2;
  }

  .progress_bar_slide {
    position: absolute;
    width: 750px;
    height: 40px;
    margin-top: -15px;
    // background: red;
  }

  .progress_bar_point_box {
    position: absolute;
    width: 40px;
    height: 40px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -10px;
  }
  .progress_bar_point {
    width: 8px;
    height: 8px;
    opacity: 0.4;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    transition: height 100ms, width 100ms, top 100ms;
  }
}

.btm_box {
  z-index: 3;
  position: absolute;
  bottom: 0;
  height: 2px;
  left: 0;
  padding-left: 10px;
  padding-right: 50px;
  display: flex;
  align-items: center;
  bottom: 120px;
  .btm_box_light {
    position: absolute;
    top: -2px;
    height: 2px;
    width: 750px;
    left: 0;
    border-radius: 4px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0.3) 100%
    );
    transform: scaleX(0.1);
    animation: lineAni 600ms;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    z-index: 2;
  }
}

.v_control {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 750px;
  height: 100%;
  transition: all;
  transition-duration: 100ms;
  .v_pause {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 160px;
    height: 160px;
    img {
      width: 160px;
      height: 160px;
    }
  }

  .v_time {
    position: absolute;
    bottom: 278px;
    width: 750px;
    font-size: 40px;
    font-weight: 400;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    .v_time_txt1 {
      width: 140px;
      text-align: right;
      margin-right: 16px;
    }

    .v_time_txt2 {
      width: 140px;
      color: rgba(255, 255, 255, 0.7);
      text-align: left;
      margin-left: 16px;
      opacity: 0.8;
    }

    .v_time_txt_icon {
      font-size: 28px;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .v_ft {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 126px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #000;
    .v_progress {
      position: absolute;
      top: 24px;
      left: 60px;
      width: 626px;
      height: 40px;
    }

    .ft_txt {
      width: 82px;
      text-align: center;
      font-size: 20px;
      color: #fff;
    }
  }

  .tabBg {
    background: transparent;
  }
  .save_area {
    padding-bottom: 0;
  }
}
.bottomOut {
  animation: bottomOut 500ms;
  animation-fill-mode: forwards;
}

@keyframes bottomOut {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(100px);
  }
}

.bottomIn {
  animation: bottomIn 500ms;
  animation-fill-mode: forwards;
}

@keyframes bottomIn {
  from {
    transform: translateY(100px);
  }

  to {
    transform: translateY(0);
  }
}

.overlay_btm_box {
  transform: translateY(0%);
  box-sizing: border-box;
  opacity: 1;
  z-index: 2;
  width: 750px;
  position: absolute;
  bottom: 0;
  height: 126px;
  background: #000;
  left: 0;
  padding-left: 10px;
  padding-right: 50px;
  display: flex;
  align-items: center;
  transition: all 300ms;
  .btm_box_tit {
    margin-right: 40px;
    padding-left: 8px;
    display: flex;
    align-items: center;
    transform: translateX(-15px);

    p {
      font-size: 30px;
      font-weight: 600;
      color: #fff;
    }

    .btm_box_tit_name {
      flex: 1;
      overflow: hidden;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      white-space: normal; // 规定段落中的文本不进行换行
      word-break: break-all; // 允许单词中换行，在容器的最右边进行断开不会浪费控件
      word-wrap: break-word; // 防止长单词溢出，单词内部短句
    }
  }
  .btm_box_left {
    width: 48px;
    height: 48px;
    margin-left: 14px;
  }
  .btm_box_right {
    width: 40px;
    height: 40px;
    margin-left: auto;
    // margin-right: 24px;
  }
}

.fadeBottomOut {
  transform: translateY(100%);
  opacity: 0;
}
</style>
